import { render, staticRenderFns } from "./zhengce_detail.vue?vue&type=template&id=291edcdb&scoped=true"
import script from "./zhengce_detail.vue?vue&type=script&lang=js"
export * from "./zhengce_detail.vue?vue&type=script&lang=js"
import style0 from "./zhengce_detail.vue?vue&type=style&index=0&id=291edcdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291edcdb",
  null
  
)

export default component.exports